import DOMPurify from 'dompurify'

/**
 * Sanitize untrusted HTML before injecting via dangerouslySetInnerHTML.
 *
 * Rich-text content rendered here is later shown to students, so it must be
 * treated as untrusted: without sanitization an embedded <script> / onerror
 * handler could run in another user's browser and steal their session token.
 *
 * Strips scripts, event handlers and javascript: URLs while keeping the
 * formatting tags a rich-text editor produces.
 */
export function sanitizeHtml(dirty) {
  if (dirty == null) return ''
  return DOMPurify.sanitize(String(dirty), { USE_PROFILES: { html: true } })
}
